export default [
    {
        path: '/futures/sports',
        component: () => import('@/pages/sports'),
    },
  ];
  


// WEBPACK FOOTER //
// ./src/router/v2/sports/index.js